import axios from '@/utils/axios'

export function login (data) {
  return axios({
    url: '/login',
    method: 'post',
    data
  })
}

export function logout () {
  return axios({
    url: '/logout',
    method: 'delete'
  })
}

export function register (data) {
  return axios({
    url: 'users',
    method: 'post',
    data
  })
}

export function change (data) {
  return axios({
    url: '/users/' + data.username,
    method: 'put',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js